/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { PriceSettingsDto } from './PriceSettingsDto';
import {
    PriceSettingsDtoFromJSON,
    PriceSettingsDtoFromJSONTyped,
    PriceSettingsDtoToJSON,
    PriceSettingsDtoToJSONTyped,
} from './PriceSettingsDto';
import type { SimulationData } from './SimulationData';
import {
    SimulationDataFromJSON,
    SimulationDataFromJSONTyped,
    SimulationDataToJSON,
    SimulationDataToJSONTyped,
} from './SimulationData';

/**
 * 
 * @export
 * @interface GetKeyFiguresPreviousYearResponse
 */
export interface GetKeyFiguresPreviousYearResponse {
    /**
     * The previous year (the simulation planning year minus one). All data in this response is for this year.
     * @type {number}
     * @memberof GetKeyFiguresPreviousYearResponse
     */
    previousYear: number;
    /**
     * Product-level pricing data for the previous year. Null when the previous-year data cannot be built, for example when no preferred demand forecast exists.
     * @type {Array<SimulationData>}
     * @memberof GetKeyFiguresPreviousYearResponse
     */
    simulationData: Array<SimulationData> | null;
    /**
     * Price settings per price unit for the previous year, ordered by price unit ID. Null when the previous-year data cannot be built, for example when no preferred demand forecast exists.
     * @type {Array<PriceSettingsDto>}
     * @memberof GetKeyFiguresPreviousYearResponse
     */
    priceSettings: Array<PriceSettingsDto> | null;
}

/**
 * Check if a given object implements the GetKeyFiguresPreviousYearResponse interface.
 */
export function instanceOfGetKeyFiguresPreviousYearResponse(value: object): value is GetKeyFiguresPreviousYearResponse {
    if (!('previousYear' in value) || value['previousYear'] === undefined) return false;
    if (!('simulationData' in value) || value['simulationData'] === undefined) return false;
    if (!('priceSettings' in value) || value['priceSettings'] === undefined) return false;
    return true;
}

export function GetKeyFiguresPreviousYearResponseFromJSON(json: any): GetKeyFiguresPreviousYearResponse {
    return GetKeyFiguresPreviousYearResponseFromJSONTyped(json, false);
}

export function GetKeyFiguresPreviousYearResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetKeyFiguresPreviousYearResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'previousYear': json['previousYear'],
        'simulationData': (json['simulationData'] == null ? null : (json['simulationData'] as Array<any>).map(SimulationDataFromJSON)),
        'priceSettings': (json['priceSettings'] == null ? null : (json['priceSettings'] as Array<any>).map(PriceSettingsDtoFromJSON)),
    };
}

export function GetKeyFiguresPreviousYearResponseToJSON(json: any): GetKeyFiguresPreviousYearResponse {
    return GetKeyFiguresPreviousYearResponseToJSONTyped(json, false);
}

export function GetKeyFiguresPreviousYearResponseToJSONTyped(value?: GetKeyFiguresPreviousYearResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'previousYear': value['previousYear'],
        'simulationData': (value['simulationData'] == null ? null : (value['simulationData'] as Array<any>).map(SimulationDataToJSON)),
        'priceSettings': (value['priceSettings'] == null ? null : (value['priceSettings'] as Array<any>).map(PriceSettingsDtoToJSON)),
    };
}

